import { authUserInitialState } from './authUser.initialState';
import { path, pathOr } from 'ramda';
import { createSelector } from 'reselect';
import { currentUserId } from '../../utils/checkAuthorization';

export const getPendingAuthUserUpdate = state => path(['authUser', 'pendingUpdate'], state);
export const getPendingAuthUserCreate = state => path(['authUser', 'pendingCreate'], state);
export const getPendingAuthUsers = state => ({
	update: getPendingAuthUserUpdate(state),
	create: getPendingAuthUserCreate(state),
});

export const getAuthUserErrorUpdate = state => path(['authUser', 'updateError'], state);
export const getAuthUserErrorCreate = state => path(['authUser', 'createError'], state);
export const getAuthUserErrors = state => ({
	update: getAuthUserErrorUpdate(state),
	create: getAuthUserErrorCreate(state),
});
export const getTotal = state => path(['authUser', 'totalToDisplay'], state);
export const getSkip = state => path(['authUser', 'skip'], state);

export const getAuthUserById = (state, id) =>
	pathOr({}, ['authUser', 'entities'], state)[id] || authUserInitialState;
export const getEntities = state => path(['authUser', 'entities'], state);
export const getAuthUsers = createSelector(getEntities, entities => Object.values(entities));

export const getCurrentAuthUser = createSelector(
	getEntities,
	entities => entities[currentUserId()] || authUserInitialState,
);

export const isUserWiselyOnly = createSelector(
	getCurrentAuthUser,
	user => user && user.wisely_only,
);

export const disableAssignment = createSelector(
	getCurrentAuthUser,
	user => user && user.disable_assignment,
);

export const disableOtherPortfolios = createSelector(
	getCurrentAuthUser,
	user => user && user.disable_other_portfolios,
);



// WEBPACK FOOTER //
// ./src/redux/authUsers/authUser.selector.js